/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    CurationActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const fetchCurationId = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_ID && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CurationActions.receiveCurationId))
);

export const fetchCurationsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.receiveCurations))
);

export const fetchCurationEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.receiveCuration))
);

export const deleteCurationEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CurationActions.deletedCuration))
);

export const fetchCurationCountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_COUNT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.receiveCurationCount))
);

export const fetchCurationInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_INPUT_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.receiveCurationInput))
);

export const fetchCurationInputLogEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_INPUT_LOG && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.receiveCurationInputLog))
);

export const deleteCurationInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_INPUT_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, CurationActions.deletedCurationInput))
);

export const updateCurationInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_INPUT_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CurationActions.updatedCurationInput))
);

export const createCurationInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_INPUT_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CurationActions.createdCurationInput))
);

export const createCurationRouteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.CURATION_ROUTE_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, CurationActions.createdCurationRoute))
);
